import { ConstructorSchema } from '@/common/mapper/types';
import Morphism from 'morphism';

export function registerSchemas(constructorSchemas: ConstructorSchema<any, any>[]) {
  constructorSchemas.forEach(s => {
    if (!Morphism.getMapper(s.constructor)) {
      Morphism.register(s.constructor, s.schema);
    }
  });
}
